export default "<span class=\"vw-badge\" [ngClass]=\"'tone-' + tone\">{{ label }}</span>\r\n";